module.exports = __webpack_public_path__ + "static/media/rafaella.4f7a6d90.jpeg";